export default { 
  'error_connection' : 'сервер не отвечает',  
  'email_not_ exist' : 'такой email не существует',
  'pass_incorrect' : 'неверный пароль ',
  'email_exist' : 'такой email уже существует',  
  'error_server_db' : 'ошибка базы данных',
  'error_play_audio': 'ошибка воспроизведения аудио', 
}
